var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "image-container" }, [_c('div', { staticClass: "image", style: _vm.imageStyle }, [_c('image-previewer', { attrs: { "src": _vm.url, "width": "auto", "imageStyle": _vm.innerImageStyle, "theme": "dark" } })], 1), _vm._v(" "), _c('file-meta', _vm._b({ attrs: { "customStyle": _vm.fileMetaStyle } }, 'file-meta', _vm.fileMeta, false))], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };